module.exports = __webpack_public_path__ + "static/media/admin.c430f28c.svg";